function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* istanbul ignore file */
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import LeftCaretIcon from "@digital-hig/icon/lib/esm/ui-controls/caret-left";
import RightCaretIcon from "@digital-hig/icon/lib/esm/ui-controls/caret-right";
export var makeTabsStyles = function makeTabsStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  var getTabStyles = function getTabStyles() {
    var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
    var tab = tokens.tab;
    var padding = variant === "quiet" ? "".concat(primitives.spacings["3"], " ").concat(primitives.spacings["4"]) : "".concat(primitives.spacings["4"], " ").concat(primitives.spacings["6"]);
    return _objectSpread(_objectSpread({}, tab.default), {}, {
      fontSize: primitives.fontSizes["3"],
      fontWeight: primitives.fontWeights.stout,
      lineHeight: primitives.lineHeights.compact,
      padding: padding,
      textTransform: "none",
      "&:hover": _objectSpread({}, tab.hover),
      "&:focus-visible": _objectSpread({}, tab.focus),
      "&:active": _objectSpread({}, tab.pressed),
      "&.Mui-selected": _objectSpread(_objectSpread({}, tab.active), variant === "quiet" ? {
        backgroundColor: primitives.colors.detail.transparent
      } : {}),
      "&.Mui-selected:focus-visible": _objectSpread(_objectSpread({}, tab.focus), {}, {
        backgroundColor: tokens.colors["fill-elevation-1"],
        color: tokens.colors["ink-on-background"]
      }),
      "&.Mui-disabled": {
        opacity: tokens.opacities.disabled
      }
    });
  };
  return {
    MuiTabs: {
      defaultProps: {
        slots: {
          // eslint-disable-next-line react/display-name
          StartScrollButtonIcon: function StartScrollButtonIcon() {
            return /*#__PURE__*/React.createElement(SvgIcon, {
              fontSize: "small"
            }, /*#__PURE__*/React.createElement(LeftCaretIcon, null));
          },
          // eslint-disable-next-line react/display-name
          EndScrollButtonIcon: function EndScrollButtonIcon() {
            return /*#__PURE__*/React.createElement(SvgIcon, {
              fontSize: "small"
            }, /*#__PURE__*/React.createElement(RightCaretIcon, null));
          }
        }
      },
      styleOverrides: {
        root: {
          position: "relative",
          "&.DhigTabs--styleVariant--default": _objectSpread(_objectSpread({}, tokens.tabs.default), {}, {
            '&[class*="MuiTabs-vertical"] [class*="MuiTabs-scroller"] [class*="MuiTab-root"]': {
              maxWidth: "none",
              alignContent: "flex-start",
              flexWrap: "wrap"
            },
            '& [class*="MuiTab-root"]': getTabStyles()
          }),
          "&.DhigTabs--styleVariant--quiet": _objectSpread(_objectSpread({}, tokens.tabs.quiet), {}, {
            '& [class*="MuiTabs-scroller"]': {
              marginLeft: "-".concat(primitives.spacings["4"]),
              '& [class*="MuiTabs-indicator"]': {
                top: "unset",
                bottom: primitives.spacings["0"],
                background: "transparent",
                "&:after": {
                  width: "calc( 100% - ".concat(primitives.spacings["7"], " )"),
                  height: "2px",
                  content: "''",
                  background: tokens.colors["ink-on-background"]
                }
              }
            },
            "&.DhigTabs--extendedUnderline": {
              overflow: "unset",
              "&:before, &:after": {
                boxShadow: tokens.effects["divider-0-bottom"],
                content: "''",
                height: "100%",
                position: "absolute",
                width: "calc((100vw - 100%) / 2)"
              },
              "&:before": {
                right: "100%"
              },
              "&:after": {
                left: "100%"
              },
              '& [class*="MuiTabs-scroller"]': {
                marginLeft: primitives.spacings["0"]
              },
              '&[class*="MuiTabs-vertical"]': {
                overflow: "hidden"
              }
            },
            '&[class*="MuiTabs-vertical"]': {
              boxShadow: tokens.effects["divider-0-left"],
              '& [class*="MuiTabs-scroller"]': {
                marginLeft: primitives.spacings["0"],
                '& [class*="MuiTabs-indicator"]': {
                  background: tokens.colors["ink-on-background"]
                },
                '& [class*="MuiTab-root"]': {
                  maxWidth: "none",
                  alignContent: "flex-start",
                  flexWrap: "wrap",
                  "&.Mui-selected": {
                    boxShadow: "none",
                    "&:focus:active": {
                      boxShadow: tokens.effects["tab-highlight-left"]
                    }
                  }
                }
              }
            },
            '& [class*="MuiTab-root"]': getTabStyles("quiet")
          }),
          "& [class*='MuiTabs-scroller'] + [class*='MuiTabScrollButton-root']": {
            background: "linear-gradient(270deg, ".concat(tokens.colors["fade-gradient-opaque"], " 0%, ").concat(tokens.colors["fade-gradient-semi-opaque"], " 33.33%, ").concat(tokens.colors["fade-gradient-semi-transparent"], " 66.67%, ").concat(tokens.colors["fade-gradient-transparent"], " 100%)"),
            right: primitives.spacings["0"],
            left: "unset"
          }
        },
        indicator: {
          left: primitives.spacings["0"],
          top: primitives.spacings["0"],
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }
    },
    MuiTab: {
      defaultProps: {
        wrapped: true,
        tabIndex: 0
      },
      styleOverrides: {
        root: {
          border: "".concat(primitives.borderWidths.large, " solid transparent"),
          minWidth: "unset"
        }
      }
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          color: tokens.colors["ink-on-background"],
          height: "100%",
          width: primitives.spacings["8"],
          position: "absolute",
          zIndex: 1,
          background: "linear-gradient(270deg, ".concat(tokens.colors["fade-gradient-transparent"], " 0%, ").concat(tokens.colors["fade-gradient-semi-transparent"], " 33.33%, ").concat(tokens.colors["fade-gradient-semi-opaque"], " 66.67%, ").concat(tokens.colors["fade-gradient-opaque"], " 100%)"),
          left: primitives.spacings["0"],
          '& [class*="MuiSvgIcon"]': {
            display: "none"
          },
          "&:hover": {
            '& [class*="MuiSvgIcon"]': {
              display: "inline-block"
            }
          },
          // Not addding theming for breakpoints; this is only to override the MUI default.
          "@media (max-width: 599.95px)": _defineProperty({}, "&[class*=\"MuiTabs-scrollButtonsDesktop\"]", {
            display: "flex"
          })
        }
      }
    }
  };
};